/*
================================================================================
 文件 5: src/components/Layout.js
 (一个通用的页面布局组件，包含导航栏)
================================================================================
*/
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { demoModeLabel, isDemoMode } from '../config/environment';

export default function Layout({ title, children, actions, fullWidth = false }) {
    const { user, logout } = useAuth();
    const { t } = useTranslation();

    // 根据 fullWidth 选择容器类
    const containerClass = fullWidth
        ? "w-full py-4 px-4 sm:px-6 lg:px-8"
        : "max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8";
    const mainContainerClass = fullWidth
        ? "w-full py-6 px-4 sm:px-6 lg:px-8"
        : "max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8";

    return (
        <div className="min-h-screen bg-[var(--background)] transition-colors duration-300">
            {isDemoMode && (
                <div className="bg-amber-100 border-b border-amber-300 text-amber-900 px-4 py-2 text-sm font-semibold text-center">
                    {demoModeLabel} - 静的デモです。入力内容は正式環境・実データに反映されません。
                </div>
            )}
            <header className="bg-[var(--surface)] border-b border-[var(--border)] sticky top-0 z-30 transition-colors duration-300">
                <div className={containerClass}>
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-xl sm:text-2xl font-bold text-[var(--text-primary)] tracking-tight">{title}</h1>
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 w-full sm:w-auto">
                            <div className="w-full sm:w-auto">
                                {actions}
                            </div>
                            <div className="flex items-center gap-3 pl-4 border-l border-[var(--border)]">
                                <span className="hidden sm:inline text-sm font-medium text-[var(--text-secondary)]">
                                    こんにちは, <b className="text-[var(--text-primary)]">{user?.username}</b> ({user?.role})
                                </span>
                                <button
                                    onClick={logout}
                                    className="px-4 py-2 min-w-[80px] text-sm font-medium rounded-md text-[var(--text-secondary)] bg-[var(--neutral-100)] hover:bg-[var(--neutral-200)] hover:text-[var(--text-primary)] transition-all duration-200"
                                >
                                    {t('logout')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main className="animate-fade-in">
                <div className={mainContainerClass}>
                    {children}
                </div>
            </main>
        </div>
    );
}
